import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataMm from './phonics/phonics_data_mm';

function PhonicsMm() {
  return <PhonicsAtoZ letterData={letterDataMm} />;
}

export default PhonicsMm;